
import { googleTagManagerService } from '@/shared/services/GoogleTagManagerService';
import { defineComponent } from 'vue';
import { mapGetters } from 'vuex';

export default defineComponent({
  props: {
    ad: Object as any,
  },
  data() {
    return {
      menuVisible: false,
      sharing: {
        url: window.location.href,
        title: this.ad.title,
        //description: (this.ad as any).description, //mailto issue in chrome because url can only contains cca2000 chars
      },
      networks: [],
      options: {
        networks: {
          whatsappweb: 'https://web.whatsapp.com/send?text=@t%0D%0A@u%0D%0A@d'
        }
      }
    };
  },
  computed: {
    ...mapGetters(['isMobile']),
  },
  created() 
  {
     this.networks = [
        { network: 'facebook', name: 'Facebook', icon: 'icon-facebook', color: '#1877f2' },
        { network: this.isMobile ? 'whatsapp' : 'whatsappweb', name: 'Whatsapp', icon: 'icon-whatsapp', color: '#25d366', title: this.ad.title + '\n' },
        { network: 'email', name: 'Email', icon: 'icon-email', color: '#41b883' },
      ];
  },
  methods: {
    onClickOutside() {
      this.menuVisible = false;
    },
    open() {
      googleTagManagerService.send({
        event: 'zdielat_click',
      });
    },
  },
});
